"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var TrackTrace_1 = require("./apis/TrackTrace");
var auth_1 = require("./auth");
var Config_1 = require("./Config");
var shipments_1 = require("./mock/shipments");
var models_1 = require("./models");
var communications_1 = require("./models/communications");
var Communications = __importStar(require("./models/communications"));
var Image_1 = require("./models/delivery/Image");
var batching_1 = require("./utils/batching");
var batchApi_1 = require("./utils/batching/batchApi");
var TrunkrsSDK = /** @class */ (function () {
    function TrunkrsSDK(options) {
        var _this = this;
        this.Image = Image_1.Image;
        this.batchApi = new batchApi_1.BatchApi();
        this.createTestData = function (apiKey) { return __awaiter(_this, void 0, void 0, function () {
            var mShipments, shipments, _i, shipments_2, shipment;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (Config_1.config.getOption('mode') === 'PRODUCTION') {
                            throw new Error("No mock shipments for production please");
                        }
                        return [4 /*yield*/, this.Auth().setValue(models_1.AUTH_VALUES.API_KEY, apiKey)];
                    case 1:
                        _a.sent();
                        mShipments = shipments_1.mockShipment();
                        return [4 /*yield*/, Promise.all(mShipments.map(function (shipment) { return _this.Shipment().announce(shipment); }))];
                    case 2:
                        shipments = _a.sent();
                        _i = 0, shipments_2 = shipments;
                        _a.label = 3;
                    case 3:
                        if (!(_i < shipments_2.length)) return [3 /*break*/, 6];
                        shipment = shipments_2[_i];
                        if (!(Math.random() < 0.3)) return [3 /*break*/, 5];
                        return [4 /*yield*/, shipment.sortToRegion()];
                    case 4:
                        _a.sent();
                        _a.label = 5;
                    case 5:
                        _i++;
                        return [3 /*break*/, 3];
                    case 6: return [4 /*yield*/, this.Auth().setValue(models_1.AUTH_VALUES.API_KEY, undefined)];
                    case 7:
                        _a.sent();
                        return [2 /*return*/, shipments.map(function (shipment) { return shipment.getTrunkrsNumber; })];
                }
            });
        }); };
        Config_1.config.setConfig(options);
        if (options.enableBatching) {
            batching_1.hookUpBatching();
        }
    }
    Object.defineProperty(TrunkrsSDK.prototype, "batching", {
        get: function () {
            return this.batchApi;
        },
        enumerable: true,
        configurable: true
    });
    TrunkrsSDK.prototype.Communication = function () {
        return Communications;
    };
    TrunkrsSDK.prototype.Auth = function () {
        return auth_1.auth;
    };
    TrunkrsSDK.prototype.Shipment = function () {
        return models_1.Shipment;
    };
    TrunkrsSDK.prototype.ShipmentComment = function () {
        return models_1.ShipmentComment;
    };
    TrunkrsSDK.prototype.Tour = function () {
        return models_1.Tour;
    };
    TrunkrsSDK.prototype.Driver = function () {
        return models_1.Driver;
    };
    TrunkrsSDK.prototype.Subco = function () {
        return models_1.Subco;
    };
    TrunkrsSDK.prototype.TourState = function () {
        return models_1.TourState;
    };
    TrunkrsSDK.prototype.GeoStamp = function () {
        return models_1.GeoStamp;
    };
    TrunkrsSDK.prototype.ReasonCode = function () {
        return models_1.ReasonCode;
    };
    TrunkrsSDK.prototype.Location = function () {
        return models_1.Location;
    };
    TrunkrsSDK.prototype.Neighbour = function () {
        return models_1.Neighbour;
    };
    TrunkrsSDK.prototype.DriverDailyReport = function () {
        return models_1.DriverDailyReport;
    };
    TrunkrsSDK.prototype.Merchant = function () {
        return models_1.Merchant;
    };
    TrunkrsSDK.prototype.TrackAndTalk = function () {
        return communications_1.TrackAndTalk;
    };
    TrunkrsSDK.prototype.Conversation = function () {
        return communications_1.Conversation;
    };
    TrunkrsSDK.prototype.ShipmentAlert = function () {
        return models_1.ShipmentAlert;
    };
    TrunkrsSDK.prototype.CollectionTour = function () {
        return models_1.CollectionTour;
    };
    TrunkrsSDK.prototype.NonCollectionReasonCode = function () {
        return models_1.NonCollectionReasonCode;
    };
    TrunkrsSDK.prototype.LinehaulTour = function () {
        return models_1.LinehaulTour;
    };
    TrunkrsSDK.prototype.FreezerLog = function (subcoId) {
        return new models_1.FreezerLog(subcoId);
    };
    TrunkrsSDK.prototype.UserPreferences = function () {
        return models_1.UserPreferences;
    };
    TrunkrsSDK.prototype.Warehouse = function () {
        return models_1.Warehouse;
    };
    TrunkrsSDK.prototype.ReasonCodeUnscannable = function () {
        return models_1.ReasonCodeUnscannable;
    };
    TrunkrsSDK.prototype.Inventory = function () {
        return models_1.Inventory;
    };
    TrunkrsSDK.prototype.Debtor = function () {
        return models_1.Debtor;
    };
    TrunkrsSDK.prototype.getTrackTraceApiInstance = function (trunkrsNr, postalCode) {
        return new TrackTrace_1.TrackTrace(trunkrsNr, postalCode);
    };
    return TrunkrsSDK;
}());
exports.TrunkrsSDK = TrunkrsSDK;
